<div class="card-header border-0">
  <h3 class="card-title d-flex justify-content-between w-100 align-items-center">
    <span class="card-label fw-bolder fs-3">{{tabTitle}}</span>
    <ng-content select="[miniTableControls]"></ng-content>
  </h3>
</div>
<div class="card-body py-3">
  <div class="tab-content">
    <div
      class="tab-pane fade"
      [ngClass]="'show active'"
      id="kt_table_widget_5_tab_1"
    >
      <div>
        <table
          class="
            table table-row-bordered
            text-gray-600
            align-middle
            gs-0
            gy-4
            mini-table__table
            w-100
          "
          style="table-layout: fixed;"
        >
          <tbody class="fw-normal fs-7">
            <ng-content select="[miniTableBody]"></ng-content>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
